/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpsticketsexamplecomInputs */

const en_httpsticketsexamplecom = /** @type {(inputs: HttpsticketsexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://tickets.example.com`)
};

const de_httpsticketsexamplecom = /** @type {(inputs: HttpsticketsexamplecomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://tickets.example.com`)
};

/**
* | output |
* | --- |
* | "https://tickets.example.com" |
*
* @param {HttpsticketsexamplecomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const httpsticketsexamplecom = /** @type {((inputs?: HttpsticketsexamplecomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpsticketsexamplecomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpsticketsexamplecom(inputs)
	return de_httpsticketsexamplecom(inputs)
});